<div class="mb-24">
  <div class="instances-table max-width-lg pb-20">
    <!-- <div class="mat-display-1 fw-600 mt-30 mb-20">{{'TENANT_MGMT.TENANTS' | transloco}}</div> -->
    <section #loungeCatalogue class="flex flex-col justify-center items-center max-width-lg catalogue-class pb-10">

      <div class="flex flex-row mt-10 mb-10 w-100-percent">
        <div class="mat-display-2">{{ 'COST_MGMT.COST_DETAILS.HEADER' | transloco }}</div>


        <div class="flex flex-col justify-end w-100-percent mr-30">
          <app-search-filter (changed)="loadTenantsSearchFilterDetails($event)" class="ml-auto">
          </app-search-filter>
          <div class="flex justify-end mat-headline-6 mr-80">{{ 'COST_MGMT.COST_DETAILS.RESULTS_FOUND' | transloco:
            {
              totalSubscription:
              totalSubscription
            } }}
          </div>
        </div>
      </div>
    </section>
    <div>
      <mat-divider class="mb-12"></mat-divider>
    </div>
    <div *ngIf="dataLoaded" class="flex flex-col">
      <div class="flex flex-row mat-subtitle-2 table-head">
        <div [style.max-width.%]="30">{{ 'COST_MGMT.COST_DETAILS.TENANT_NAME' | transloco }}</div>
        <div [style.max-width.%]="30">{{ 'COST_MGMT.COST_DETAILS.SUBSCRIPTION_ID' | transloco }}</div>
        <div [style.max-width.%]="30">{{ 'COST_MGMT.COST_DETAILS.COST' | transloco }}</div>
      </div>
    </div>
    <ng-container *ngFor="let costDetails of filteredCostMetrics" [ngTemplateOutletContext]="{costDetails: costDetails}"
                  [ngTemplateOutlet]="tenantRow">
    </ng-container>

  </div>

</div>
<ng-template #tenantRow let-costDetails="costDetails">
  <div class="flex flex-col table-tr">
    <div [routerLink]="['/', basetenant, basepath, costDetails.tenantId]" class="flex justify-center items-center row-content fw-400">
      <!-- <div class="w-25-percent tenant-name word-break-word">{{ tenant.id || ('INSTANCE_SUMMARY.NA' | transloco) }}</div> -->
      <div class="tenant-environment" [style.max-width.%]="30">{{ costDetails.tenantId }}</div>
      <div class="tenant-region" [style.max-width.%]="30">{{ costDetails.subscriptionId || ('INSTANCE_SUMMARY.NA' | transloco) }}</div>
      <div class="tenant-status" [style.max-width.%]="30">{{ costDetails.cost | number : '1.2-2' }} ({{ costDetails.currencyType }}
        )
      </div>
    </div>
  </div>
</ng-template>
